import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import commonNetwork from "../../common/api/commonNetwork";
import { FetchResultType } from "../fetchTypes";
import { CustomerListType } from "../../common/types";

// PAGINATION EKLENDİ

export const getWebCustomerList = createAsyncThunk(
    "/customer/all-from-web",
    async (params: any, { rejectWithValue }) => {
        try {
            // authToken eklenecek cookie,local vs biryerden okunup
            const { data, errorMessage, isSuccess } = await commonNetwork.get("/customer/all-from-web", params);
            if (isSuccess) {
                // Artık pagination'lı gelecek => data = { data: [...], totalCount: 123 }
                const list = data.data || [];  // customer listesi
                const totalCount = data.totalCount || 0;
                const currentPage = data.currentPage || 1;

                return { list, totalCount, currentPage };  // explicit döndür
            } else {
                return rejectWithValue(data);
            }
        } catch (e: any) {
            return rejectWithValue(e.data.message);
        }
    }
);

export const getWebCustomerById = createAsyncThunk(
    "/customer/:customerid",
    async (id: any, { rejectWithValue }) => {
        const { data, errorMessage, isSuccess } = await commonNetwork.get(`/customer/${id}`)
        try {
            if (isSuccess) {
                return data;
            } else {
                return rejectWithValue(data);
            }
        } catch (error: any) {
            return rejectWithValue(error.data.message)
        }
    }
)

export const createWebCustomer = createAsyncThunk(
    "/customer",
    async (params: any, { rejectWithValue }) => {
        try {
            const { data, errorMessage, isSuccess } = await commonNetwork.post("/customer", params);

            if (isSuccess) {
                return data;
            } else {
                return rejectWithValue(data);
            }
        } catch (error: any) {
            return rejectWithValue(error.data.message)
        }
    }
)


export interface webCustomerStateType extends FetchResultType {
    customerList: Array<CustomerListType>
}
export const webCustomersSlice = createSlice({
    name: "webCustomers",
    initialState: {
        customerList: [],
        totalCount: 0,
        currentPage: 1,
        isfirmAvailable: true,
        isFetching: false,
        isSuccess: false,
        isError: false,
        errorMessage: "",
        isFetchComplete: false
    },
    reducers: {
        clearState: (state) => {
            state.customerList = [];
            state.isFetching = false;
            state.isSuccess = false;
            state.isError = false;
            state.isFetchComplete = false;
            return state;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(getWebCustomerList.fulfilled, (state, { payload }) => {
            state.customerList = payload.list; // list
            state.totalCount = payload.totalCount; // totalCount
            state.currentPage = payload.currentPage; // currentPage
            state.isFetching = false;
            state.isSuccess = true;
            state.isError = false;
            state.isFetchComplete = true;
            return state;
        });
        builder.addCase(getWebCustomerList.rejected, (state, { payload }) => {
            state.isFetching = false;
            state.isError = true;
            // state.errorMessage = payload.message;
        });
        builder.addCase(getWebCustomerList.pending, (state) => {
            state.isFetching = true;
        });
    },
});
export const { clearState } = webCustomersSlice.actions;

export const webCustomersSelector = (state: any) => state.webCustomers;

export const webCustomersReducer = webCustomersSlice.reducer;
